import { DashboardContext } from "@/layouts/DashboardLayout";
import { useContext } from "react";

export const useLanguage = () => {
    const { activeLanguage } = useContext(DashboardContext);
    return activeLanguage;
};
